import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    secondaryTitle: {
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
    },
    contentWrapper: {
      marginTop: "24px",
      gap: "32px",
      [theme.breakpoints.down("1420")]: {
        flexDirection: "column !important",
        "& > svg": {
          display: "none",
        },
      },
    },
    mobileView: {
      flexDirection: "column !important",
      "& > * + * ": {
        marginLeft: "0",
      },
    },
    sideMenu: {
      width: "100%",
    },
    optionalFieldWrapper: {
      position: "relative",
      padding: "16px 32px",
      width: "100%",
      marginTop: "10px",
    },
    optionalFieldContent: {
      [theme.breakpoints.down("630")]: {
        flexDirection: "column",
        gap: "16px",
      },
    },
    rangeSliderWrapper: {
      maxWidth: "515px",
      marginLeft: "auto",
    },
    optionalField: {
      paddingLeft: "12px",
    },
    closeXIcon: {
      position: "absolute",
      left: "16px",
      cursor: "pointer",
    },
    cardContainer: {
      maxWidth: "426px",
      padding: "16px 32px",
      minHeight: "100vh",
      [theme.breakpoints.down("1420")]: {
        width: "100%",
        maxWidth: "initial",
        minHeight: "initial",
      },
      [theme.breakpoints.down("500")]: {
        padding: "16px",
      },
    },
    mandotaryForm: {
      "& > * + * ": {
        borderTop: "1px solid #EAECF0",
        paddingTop: "20px",
        marginTop: "20px",
      },
      padding: "24px 32px",
      "& input[type=number]": {
        // Firefox
        "-moz-appearance": "textfield",

        // Chrome, Safari, Edge, Opera
        "&::-webkit-inner-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
        "&::-webkit-outer-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
      },
      [theme.breakpoints.down("500")]: {
        padding: "16px",
      },
    },

    button: {
      width: "100%",
      padding: "20px 16px",
      borderRadius: "12px",
      margin: "12px 0",
      justifyContent: "flex-start",
    },
    formContent: {
      flexBasis: "70%",
      maxWidth: "initial",
      background: theme.palette.background.gray_50,
    },
    inputwrapper: {
      width: "100% !important",
      [theme.breakpoints.down("500")]: {
        "& label": {
          minWidth: "auto",
        },
      },
    },
    label: {
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "20px",
      color: theme.palette.text.secondary,
      paddingLeft: "12px",
    },
    fieldLabel: {
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "20px",
      color: theme.palette.text.secondary,
      width: "296px",
      maxWidth: "296px",
      [theme.breakpoints.down("1420")]: {
        width: "100%",
        maxWidth: "initial",
      },
    },
    checkboxWrapper: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      flexWrap: "wrap",
    },
    checkboxLabel: {
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
    },
    switchLabel: {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "24px",
    },
    subtitle: {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "24px",
    },
    subText: {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      marginTop: "16px",
      color: theme.palette.text.tertiary,
    },
    activeField: {
      borderColor: theme.palette.border.brandSolid,
    },
    viewOrderButton: {
      color: theme.palette.text.tertiary,
      fontWeight: "600",
      fontSize: "14px",
      position: "absolute",
      right: "14px",
      top: "12px",
      lineHeight: "20px",
      margin: "0 !important",
    },
    errorMessage: {
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: 400,
      color: theme.palette.text.error_primary,
    },
    accordionWrapper: {
      boxShadow: "none",
      "&::before": {
        display: "none",
      },
      "&::after": {
        display: "none",
      },
    },
    accordionDetails: {
      flexDirection: "column",
    },
    accordionSummary: {
      padding: 0,
      "& > div": {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      },
      "&::before": {
        display: "none",
      },
      "&::after": {
        display: "none",
      },
    },
    accordionSummaryText: {
      fontSize: "16px",
      fontWeight: "600",
      lineHeight: "24px",
      color: theme.palette.text.brand_secondary,
      margin: "0",
      paddingRight: "6px",
    },
    switchWrapper: {
      [theme.breakpoints.down("690")]: {
        flexDirection: "column",
        paddingBottom: "16px",
      },
    },
    textFieldWrapper: {
      position: "relative",
    },
    criteriaSubText: {
      padding: "16px 0",
      margin: "0",
    },
    stepperActionContainer: {
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down("776")]: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
  };
});
